<template>
  <div
    class="taktarea"
    :style="`
      width: calc((${project_length + 2} * (var(--workpackage_width) + 8px) + ${header_width}) * var(--taktplan_zoom));
      ${backlog?'background-color: var(--v-color-4-base);':''}
      ${height?`height: ${height}`:''}
      `"
      >
      <slot name="taktarea_header"/>
      <slot name="taktarea"/>
  </div>
</template>
<script>
export default {
  props: ['project_length', 'header_width', 'backlog', 'height'],
  // updated() {
  //   console.log('taktarea updated');
  // }
}
</script>
<style>
  .taktarea {
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    /* box-shadow: 0px 1px 0px 0px #424242; */
    flex-shrink: 0;
    /* border-bottom: solid 1px #212121; */
    height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom));
    will-change: height;
  }
</style>
